import i18n from 'Pods/Shared/I18nHome'

const normalize = (str) => {
  if (typeof str !== 'string') return ''
  return str.startsWith('/') ? str : `/${str}`
}

// Strip diacritics + remove any remaining non-ASCII characters so route paths
// never end up Cyrillic/accented in URLs. Server does I18n.transliterate;
// this is the JS parity guard for Issue #8 (homepage buttons producing
// URL-encoded Cyrillic paths like /ru/3d-%D0%BC%D0%BE%D0%B4%D0%B5%D0%BB%D0%B8).
const toAscii = (str) => {
  if (typeof str !== 'string') return ''
  return str.normalize('NFD').replace(/\p{M}/gu, '').replace(/[^\x00-\x7F]/g, '')
}

export function localizedRoute({ key, locale, ns = 'new-home' }) {
  const raw = i18n.t(`routes.${key}`, { ns, lng: locale })
  const route = typeof raw === 'string' ? raw : ''
  const ascii = toAscii(route)
  const path = normalize(ascii)
  const prefix = locale === 'en' ? '' : `/${locale}`
  return (prefix + path).replace(/\/{2,}/g, '/')
}

function serializeQuery(params) {
  const parts = []
  Object.keys(params || {}).forEach((k) => {
    const v = params[k]
    if (v === undefined || v === null) return
    if (Array.isArray(v)) {
      const arrayKey = `${k}[]`
      v.forEach((iv) => parts.push(`${encodeURIComponent(arrayKey)}=${encodeURIComponent(String(iv))}`))
    } else {
      parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    }
  })
  return parts.join('&')
}

export function withQuery(path, params, tag = '') {
  const qs = serializeQuery(params)

  if (tag == '')  return qs ? `${path}?${qs}` : path

  return qs ? `${path}/${tag}?${qs}` : `${path}/${tag}`
}

export const modelsPath      = (locale, params, tag) => withQuery(localizedRoute({ key: 'models', locale }), params, tag)
export const printModelsPath = (locale, params) => withQuery(localizedRoute({ key: 'print-models', locale }), params)
